import { Box, Flex, Paper, Text, Title } from "@mantine/core";
import { IconSearch, IconShieldCheck, IconLock } from "@tabler/icons-react";

export default function WhyGTConnectSection() {
  return (
    <Box bg="var(--mantine-color-primary-0)" py={60}>
      <Flex direction="column" align="center" px="xl" maw={1200} mx="auto" w="100%">
        <Flex direction="column" align="center" gap="xs" mb="xl">
          <Title order={2} ta="center">
            Why GT Setu
          </Title>
          <Text c="slate.6" ta="center">
            We've built the platform we wished existed when navigating global business partnerships
          </Text>
        </Flex>

        <Flex gap={60} justify="center" wrap="wrap" direction={{ base: "column", sm: "row" }} w="100%">
          <Paper radius="lg" p="xl" flex={1} bg="white">
            <Flex direction="column" gap="sm">
              <Box
                w={48}
                h={48}
                style={{
                  borderRadius: 8,
                  backgroundColor: "var(--mantine-color-primary-0)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <IconSearch size={24} color="var(--mantine-color-primary-6)" />
              </Box>
              <Text fw={600}>Autonomous Discovery</Text>
              <Text fz="sm" c="slate.6">
                Browse verified companies without revealing your identity. Only share details when you're ready to
                connect.
              </Text>
            </Flex>
          </Paper>

          <Paper radius="lg" p="xl" flex={1} bg="white">
            <Flex direction="column" gap="sm">
              <Box
                w={48}
                h={48}
                style={{
                  borderRadius: 8,
                  backgroundColor: "var(--mantine-color-green-0)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <IconShieldCheck size={24} color="var(--mantine-color-green-6)" />
              </Box>
              <Text fw={600}>Verified Credentials</Text>
              <Text fz="sm" c="slate.6">
                Every company undergoes comprehensive compliance verification including business licenses,
                certifications.
              </Text>
            </Flex>
          </Paper>

          <Paper radius="lg" p="xl" flex={1} bg="white">
            <Flex direction="column" gap="sm">
              <Box
                w={48}
                h={48}
                style={{
                  borderRadius: 8,
                  backgroundColor: "var(--mantine-color-primary-0)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <IconLock size={24} color="var(--mantine-color-primary-6)" />
              </Box>
              <Text fw={600}>Secure Collaboration</Text>
              <Text fz="sm" c="slate.6">
                Work together in our structured workspace with NDAs, document control, and audit logs.
              </Text>
            </Flex>
          </Paper>
        </Flex>
      </Flex>
    </Box>
  );
}
